export default "__VITE_ASSET__09460461__"